(() => {
  if (!document.querySelector(".lp-sdgs")) return;
$(window).on('load orientationchange resize', function(){
    if (Math.abs(window.orientation) === 90) {
        // 横向きになったときの処理
        $('.landscape_alert').show();
    } else {
        // 縦向きになったときの処理
        $('.landscape_alert').hide();
    }
});

$(function () {
  $('.header__menu').on('click', function () {
    $('.menu-trigger').toggleClass('menuactive');
		$('.header nav').toggleClass('open');
    return false;
  });
   $('.menu-trigger').on('click', function () {
    $('.menu-trigger').toggleClass('menuactive');
		$('.header nav').toggleClass('open');
    return false;
  });
  var startPos = 0,winScrollTop = 0;
	$(window).on('scroll',function(){
			winScrollTop = $(this).scrollTop();
			if (winScrollTop >= startPos) {
				if(winScrollTop >= 200){
					$('.header').addClass('fixed');
				}
			} else {
					$('.header').removeClass('fixed');
			}
			startPos = winScrollTop;
	});
});

$(function() {
    var showFlag = false;
    var topBtn = $('#page-top');    
    topBtn.css('bottom', '-100px');
    var showFlag = false;
    $(window).scroll(function () {
        if ($(this).scrollTop() > 100) {
            if (showFlag == false) {
                showFlag = true;
                topBtn.stop().animate({'bottom' : '20px'}, 200); 
            }
        } else {
            if (showFlag) {
                showFlag = false;
                topBtn.stop().animate({'bottom' : '-100px'}, 200); 
            }
        }
    });
    //スクロールしてトップ
    topBtn.click(function () {
        $('body,html').animate({
            scrollTop: 0
        }, 500);
        return false;
    });
});

$(function(){
  $('a[href^="#"]').click(function(){
    var speed = 500;
    var href= $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position = target.offset().top;
    $("html, body").animate({scrollTop:position}, speed, "swing");
    return false;
  });
});






      
	// 最初に、ビューポートの高さを取得し、0.01を掛けて1%の値を算出して、vh単位の値を取得
	let vh = window.innerHeight * 0.01;
	// カスタム変数--vhの値をドキュメントのルートに設定
	document.documentElement.style.setProperty('--vh', `${vh}px`);      
    

})();
